import React from 'react'

import { Trans, useTranslation } from 'react-i18next'
import { useRouteError } from 'react-router-dom'

import NonIdealState from '@components/shared/NonIdealState'

interface Props {
  titleKey?: string
}

const GenericErrorPage: React.FC<Props> = ({ titleKey }: Props) => {
  const error = useRouteError()
  console.error(error)

  const { t } = useTranslation()

  return (
    <NonIdealState
      icon="warning-sign"
      title={t(titleKey ?? 'errorUnexpected.title')}
      subtitle={
        <Trans i18nKey="errorUnexpected.subtitle">
          Please try again. If the issue continues email
          <a href="mailto:support@noteflight.com" className="orange-link">
            support@noteflight.com
          </a>
          and include the URL of this page.
        </Trans>
      }
    />
  )
}

export default GenericErrorPage
